// extracted by mini-css-extract-plugin
export default {"zoomModal":"j4-z","image":"k4-z","button":"l4-z","isOverlayShown":"m4-z"};